// If you prefer a more direct approach without the helper function:

// Close popup function
function closePopup() {
  const popupData = document.querySelector(".product_popup_data");
  const popup = document.querySelector(".itg_product_template_popup");
  const body = document.body;
  
  if (popupData) popupData.innerHTML = "";
  if (popup) popup.classList.remove("active", "screen_model_btn");
  body.classList.remove("blog_popup_active");
}

// Handle all clicks using event delegation on document
document.addEventListener("click", function(e) {
  const target = e.target;
  const closestPrdPopupBtn = target.closest(".prd_popup_btn");
  const closestPrdPopupBtnSamJane = target.closest(".prd_popup_btn_sam-jane");
  const closestCloseBtn = target.closest(".product_popup_data .popup_close_btn");
  const closestChooseModel = target.closest(".choose_model_section");
  const closestMaterialLabel = target.closest(".screen__material--label");
  const closestPopup = target.closest(".itg_product_template_popup");
  
  // Handle .prd_popup_btn click
  if (closestPrdPopupBtn) {
    const innerData = closestPrdPopupBtn.querySelector(".block_how_much_storage_inner");
    const popupData = document.querySelector(".product_popup_data");
    const popup = document.querySelector(".itg_product_template_popup");
    const body = document.body;
    
    if (innerData && popupData) {
      popupData.appendChild(innerData.cloneNode(true));
    }
    if (popup) popup.classList.add("active");
    body.classList.add("blog_popup_active");
    return;
  }
  
  // Handle .prd_popup_btn_sam-jane click
  if (closestPrdPopupBtnSamJane) {
    const innerDataDe = closestPrdPopupBtnSamJane.querySelector(".block_how_much_storage_inner_de");
    const innerDataEn = closestPrdPopupBtnSamJane.querySelector(".block_how_much_storage_inner_en");
    const popupData = document.querySelector(".product_popup_data");
    const popup = document.querySelector(".itg_product_template_popup");
    const body = document.body;
    
    if (popupData) {
      if (window.location.href.includes('https://de.elitescreens.eu/')) {
        if (innerDataDe) popupData.appendChild(innerDataDe.cloneNode(true));
      } else {
        if (innerDataEn) popupData.appendChild(innerDataEn.cloneNode(true));
      }
    }
    
    if (popup) popup.classList.add("active");
    body.classList.add("blog_popup_active");
    return;
  }
  
  // Handle close button click
  if (closestCloseBtn) {
    const popupData = document.querySelector(".product_popup_data");
    const popup = document.querySelector(".itg_product_template_popup");
    const body = document.body;
    
    if (popupData) popupData.innerHTML = "";
    if (popup) popup.classList.remove("active", "screen_model_btn");
    body.classList.remove("blog_popup_active");
    return;
  }
  
  // Handle .choose_model_section click
  if (closestChooseModel) {
    const innerData = closestChooseModel.querySelector(".choose_model_content_main");
    const popupData = document.querySelector(".product_popup_data");
    const popup = document.querySelector(".itg_product_template_popup");
    const body = document.body;
    
    if (innerData && popupData) {
      popupData.appendChild(innerData.cloneNode(true));
    }
    if (popup) {
      popup.classList.add("active", "screen_model_btn");
    }
    body.classList.add("blog_popup_active");
    return;
  }
  
  // Handle .screen__material--label click
  if (closestMaterialLabel) {
    const variantMetaData = closestMaterialLabel.querySelector(".variant_meta_data");
    const targetClone = document.querySelector(".choose_model_section .first.variant_meta_data_clone");
    
    if (variantMetaData && targetClone) {
      targetClone.innerHTML = variantMetaData.innerHTML;
    }
    return;
  }
  
  // Handle clicking outside popup to close
  if (closestPopup && !target.closest('.product_popup_data')) {
    const popupData = document.querySelector(".product_popup_data");
    const popup = document.querySelector(".itg_product_template_popup");
    const body = document.body;
    
    if (popupData) popupData.innerHTML = "";
    if (popup) popup.classList.remove("active", "screen_model_btn");
    body.classList.remove("blog_popup_active");
    return;
  }
});

// Escape key handler
document.addEventListener("keydown", function(event) {
  if (event.key === "Escape") {
    closePopup();
  }
});

document.addEventListener('DOMContentLoaded', function() {
    const knobs = document.querySelectorAll('.one-xray .knob');
    if (knobs.length < 2) {
        return;
    }

    const xraySlider1knob = knobs[0];
    const xraySlider2knob = knobs[1];
    const knobOffset = window.innerHeight / 5;

    function checkInView(element, { offset = 0 } = {}) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return rect.top <= windowHeight - offset && rect.bottom >= offset;
    }

    function throttle(delay, callback) {
        let lastCall = 0;
        return function (...args) {
            const now = new Date().getTime();
            if (now - lastCall >= delay) {
                lastCall = now;
                callback(...args);
            }
        };
    }

    function handlePageScroll() {
        function triggerSliderAnimationIfInView(knobNode) {
            if (knobNode && checkInView(knobNode, { offset: knobOffset })) {
                const container = knobNode.closest('.one-xray');
                if (container && !container.classList.contains('slider-center')) {
                    container.classList.add('slider-center');
                }
            }
        }
        triggerSliderAnimationIfInView(xraySlider1knob);
        triggerSliderAnimationIfInView(xraySlider2knob);
    }

    const throttledHandlePageScroll = throttle(200, handlePageScroll);
    document.addEventListener('scroll', throttledHandlePageScroll, false);
});

document.addEventListener('DOMContentLoaded', () => {
  const var_title = document.querySelector('.cs__variant--title');
  const legend = document.querySelectorAll(".form__label span");
  const stickyAtc = document.querySelector('.cs__sticky--atc button.product-form__submit');
  const stickyAtcContainer = document.querySelector('.cs__sticky--atc');
  const mainAtcButton = document.querySelector('.product-form__submit');

  //const manualTrigger = document.querySelector('#manual-popup-trigger');
  const chatToggle = document.querySelector('#chat-toggle');
  
  if (var_title) {
    var_title.innerHTML = Array.from(legend).map((item) => item.innerText).join('/');
  }

  if (!mainAtcButton || !stickyAtcContainer || !manualTrigger || !chatToggle) return;

  const updateButtonPosition = (isSticky) => {
    const isMobile = window.innerWidth <= 576;
    
    const baseOffset = isMobile 
      ? parseInt(manualTrigger.dataset.bottomMobile) 
      : parseInt(manualTrigger.dataset.bottomDesktop);
    
    const chatBaseOffset = isMobile 
      ? parseInt(chatToggle.dataset.bottomMobile) 
      : parseInt(chatToggle.dataset.bottomDesktop);

    if (isSticky) {
      setTimeout(function() {
        const stickyHeight = stickyAtcContainer.offsetHeight;
        manualTrigger.style.bottom = (baseOffset + stickyHeight) + 'px';
        chatToggle.style.bottom = (chatBaseOffset + stickyHeight) + 'px';
      }, 500);
    } else {
      manualTrigger.style.bottom = baseOffset + 'px';
      chatToggle.style.bottom = chatBaseOffset + 'px';
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const shouldBeSticky = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        
        if (shouldBeSticky) {
          stickyAtcContainer.classList.add('active');
          updateButtonPosition(true);
        } else {
          stickyAtcContainer.classList.remove('active');
          updateButtonPosition(false);
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(mainAtcButton);

  stickyAtc.addEventListener("click", () => mainAtcButton.click());
  
  window.addEventListener('resize', () => {
    const isSticky = stickyAtcContainer.classList.contains('active');
    updateButtonPosition(isSticky);
  });
});


